<!-- 配件返厂 -->
<template>
  <div>
    <div class="detail-wrap">
      <el-form ref="editForm" :model="tenant">
        <div class="d-header">
          <div class="fl">
            <i class="el-icon-info" />
            <!-- {{ dataId ? '查看' : '新增' }}工单 -->
            结算单号：<span v-if="formData.batchNo" style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{
              formData.batchNo }}</span>
            <span v-else class="information"> 待生成</span>

            <!-- 工单状态 -->
            <span v-if="!dataId" class="information"> 申请</span>
            <span v-else-if="formData.stat == 1" class="information">制单</span>
            <span v-else-if="formData.stat == 3" class="information">审核中</span>
            <span v-else-if="formData.stat == 5" class="information">驳回</span>
            <span v-else-if="formData.stat == 7" class="information">完成</span>
            <span v-else-if="formData.stat == 9" class="information">取消</span>
          </div>
          <div>
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.stat == 1 && formData.id && !formData.processId && exchangeBillSubmit"
                       @click="startFlow">启动流程
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="(formData.stat == 1 && formData.id && !formData.processId && exchangeBillUpdate)
                             || (formData.flowStat == '审核(确认或修改最终确认冲账金额)' && updateFinalManualConfirmedAmount)
                             || (formData.flowStat == '审核(手工导入人工确认冲账金额)' && updateManualConfirmedAmount)
                             || (formData.flowStat == '审核(手工导入最终人工确认方案)' && updateFinalConfirmWay)"
                       @click="update">保存
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.stat == 1 && formData.id && !formData.processId && exchangeBillCancel"
                       @click="cancel">取消
            </el-button>
          </div>
        </div>

        <div>
          <!-- 基本信息 -->
          <dix style="display: flex;  overflow: unset!important;
            overflow-y: scroll!important;
            height: 100vh!important; ">
            <div class="d-cont edit-mce-box" style="width: 80%;">
              <div class="d-item">
                <div class="title first"><b>业务信息</b></div>
                <table class="table-detail">
                  <tbody>
                    <tr>
                      <th class="title_color">价格执行状态</th>
                      <td v-if="formData.priceStat == 0"><span class="btn_f">未执行</span></td>
                      <td v-else-if="formData.priceStat == 1"><span class="btn_t">部分执行</span></td>
                      <td v-else-if="formData.priceStat == 2"><span class="btn_t">已执行</span></td>
                      <td v-else></td>

                      <th class="title_color">是否冲账</th>
                      <td v-if="formData.isReversed == 0"><span class="btn_f">否</span></td>
                      <td v-else-if="formData.isReversed == 1"><span class="btn_t">是</span></td>
                      <td v-else></td>

                      <th class="title_color">结算总金额</th>
                      <td class="title_color">{{ formData.amount }}</td>
                    </tr>

                    <tr>
                      <th>
                        <em class="f-red">*</em>
                        申请内容
                      </th>
                      <td colspan="7">
                        <el-input type="text" autocomplete="off" placeholder="请输入"
                                  v-model="formData.applyContent" clearable />
                      </td>
                    </tr>

                  </tbody>
                </table>
              </div>

              <div class="d-item">
                <div style="display: flex;justify-content: space-between;flex-wrap: nowrap;align-items: center;">
                  <div class="title first">
                    <b>结算明细</b>
                    <el-button type="primary" v-if="updateManualConfirmedAmount && formData.flowStat == '审核(手工导入人工确认冲账金额)'" class="button-sty btn_zdy" @click="showImportManualConfirmedAmount">
                      <i class="el-icon-plus"></i>
                      批量导入人工确认冲账金额
                    </el-button>&nbsp;
                    <el-button type="primary"  v-if="updateFinalConfirmWay && formData.flowStat == '审核(手工导入最终人工确认方案)'" class="button-sty btn_zdy" @click="showImportFinalConfirmWay">
                      <i class="el-icon-plus"></i>
                      批量导入最终人工确认方案
                    </el-button>&nbsp;
                    <el-button type="primary"  v-if="sfSettleExchangeOrderInfoExport" class="button-sty btn_zdy" @click="doExcle">
                      <i class="el-icon-plus"></i>
                      导出明细
                    </el-button>&nbsp;
                  </div>
                </div>
                <div>
                  <vxe-table style="margin-top: 0px;" :stripe="true"
                             :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                             :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                             show-overflow height="210" :column-config="{ resizable: true }" @checkbox-change="selectChangeEvent"
                             @checkbox-all="selectChangeEvent" :data="formData.wkExchangeOrderDTOS">
                    <vxe-column type="checkbox" width="40" />
                    <vxe-column field="siteName" title="网点名称" width="80"/>
                    <vxe-column field="siteCode" title="网点编码" width="80"/>
                    <vxe-column field="exchangeOrderNo" title="退换货工单号" width="80"/>
                    <vxe-column field="itemCode" title="旧件产品编码" width="80"/>
                    <vxe-column field="itemName" title="旧件产品名称" width="80"/>
                    <vxe-column field="barcode" title="条码" width="80"/>
                    <vxe-column field="unOffAmount" title="待冲账金额" width="80"/>
                    <vxe-column field="manualConfirmedAmount" title="人工确认冲账金额" width="180">
                      <template #default="{row}">
                        <vxe-input
                          v-if="updateManualConfirmedAmount && formData.flowStat == '审核(手工导入人工确认冲账金额)'"
                          v-model="row.manualConfirmedAmount" placeholder="请输入"
                          clearable
                          type="number" min="0" step="0.01">
                        </vxe-input>
                        <span v-else>{{ row.manualConfirmedAmount }}</span>
                      </template>
                    </vxe-column>
                    <vxe-column field="qualityIdentifyName" title="质量鉴定" width="80"/>
                    <vxe-column field="identifyResultName" title="鉴定结果" width="80"/>
                    <vxe-column field="responsibilityIdentifyName" title="责任结果" width="80"/>
                    <vxe-column field="canFix" title="是否可维修" width="80"/>
                    <vxe-column field="dealWayName" title="处理方案名称" width="80"/>
                    <vxe-column field="confirmWay" title="人工确认方案" width="80"/>
                    <vxe-column field="finalConfirmWay" title="最终人工确认方案" width="180">
                      <template #default="{row}">
                        <vxe-input
                          v-if="updateFinalConfirmWay && formData.flowStat == '审核(手工导入最终人工确认方案)'"
                          v-model="row.finalConfirmWay" placeholder="请输入"
                          @input="handleFinalConfirmWayChange(row)"
                          clearable
                          type="number" min="0" max="1" step="0.01">
                        </vxe-input>
                        <span v-else>{{ row.finalConfirmWay }}</span>
                      </template>
                    </vxe-column>

                    <vxe-column field="finalManualConfirmedAmount" title="最终人工确认待冲账金额" width="180">
                      <template #default="{row}">
                        <vxe-input
                          v-if="updateFinalManualConfirmedAmount && formData.flowStat == '审核(确认或修改最终确认冲账金额)'"
                          v-model="row.finalManualConfirmedAmount" placeholder="请输入"
                          @input="handleFinalManualConfirmedAmountChange(row)"
                          clearable
                          type="number" min="0" step="0.01">
                        </vxe-input>
                        <span v-else>{{ row.finalManualConfirmedAmount }}</span>
                      </template>
                    </vxe-column>

                    <vxe-column field="send10No" title="追款单号" width="80"/>

                    <vxe-column field="saleOrderNo" title="冲账销售订单" width="80"/>
                    <vxe-column title="操作" width="80" fixed="right">
                      <template #default="{ row }">
                        <vxe-button v-if="formData.isReversed == 1 && !row.send10No" type="text" status="primary" @click="handleRowAction(row)">追款</vxe-button>
                      </template>
                    </vxe-column>
                  </vxe-table>
                </div>
              </div>
              <wfView  visible-key="showEdit" :wfData="wfData" :parent-target="_self"
                       @reloadWf="reloadWf"></wfView>
              <div style="height:160px"></div>
            </div>
          </dix>
        </div>
      </el-form>
      <!-- 服务区域弹窗表 -->
      <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
        <span>{{ dialogMsg }}</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="confirm">确 定</el-button>
        </span>
      </el-dialog>

      <ManualConfirmedAmountExcelUpload
        ref="ManualConfirmedAmountExcel"
        title="批量导入人工确认冲账金额"
        :url="api.sfExchangeOrder.importManualConfirmedAmountUrl"
        temp-url="/admin/sys-file/local/file/SfSettleExchangeOrderInfo.xlsx"
        @refreshDataList="reloadData"
      ></ManualConfirmedAmountExcelUpload>

      <FinalConfirmWayExcelUpload
        ref="FinalConfirmWayExcel"
        title="批量导入最终人工确认方案"
        :url="api.sfExchangeOrder.importFinalConfirmWayUrl"
        temp-url="/admin/sys-file/local/file/SfSettleExchangeOrderInfo.xlsx"
        @refreshDataList="reloadData"
      ></FinalConfirmWayExcelUpload>

      <zk-dialog v-if="showZKDialog" @doReplaceBarcodeCheck="doReplaceBarcodeCheck"
                            :visiable.sync="showZKDialog"
                            :param="orderRemarkParam"></zk-dialog>

    </div>
  </div>
</template>

<script>

import request from "@/router/axios";

import store from "@/store";
import api from "@/api/projectApi";
import { mapGetters } from "vuex";

//图片
import photoUpload from "@/components/formItem/photoUpload.vue";
import { doCheckExcle, doDownLoadExcle, doDownLoadExcleWithoutRecord, getBlob } from '@/api/intfDownloadRecord/downloadRecord.js';
import fileNames from "@/api/intfDownloadRecord/fileNames.js";
import Preview from "@/views/dialogCommon/PreviewDialog.vue";
import wfView from "@/views/dialogCommon/wfMsgDialog.vue";

import ManualConfirmedAmountExcelUpload from "./manualConfirmedAmountExcel.vue";
import FinalConfirmWayExcelUpload from "./finalConfirmWayExcel.vue";

import zkDialog from "@/views/finance/cost/exchangeBill/zkDialog.vue";



export default {
  name: 'edit',
  props: {
    _dataId: [String, Number],
    processId: [String, Number],
  },
  components: {
    Preview,
    photoUpload,
    wfView,
    ManualConfirmedAmountExcelUpload,
    FinalConfirmWayExcelUpload,
    zkDialog
  },
  data() {
    return {
      showZKDialog:false,
      updateManualConfirmedAmount: false,
      updateFinalConfirmWay: false,
      updateFinalManualConfirmedAmount: false,
      sfSettleExchangeOrderInfoExport:false,

      fixData: {},
      wfData: {
        wfEntityId: ''
      },
      processId: '',
      processDefinitions: [],
      exchangeBillSubmit:false,
      exchangeBillUpdate:false,
      exchangeBillCancel:false,
      imgVisbleURL: '',
      showPreview: false,
      isSite: false,
      viewDetailsDialog: false,

      dialogMsg: null,
      dialogVisible: false,

      formData: {
        id:null,
        priceStat:null,
        isReversed:null,
        amount:null,
        applyContent:'',
        wkExchangeOrderDTOS: null,
      },


      show3: false,

      srcList: [],
      showPhotoList0: [],

      showEdit: false,


      isEdit: false,
      dataId: '',

      showProductCategoryDialog: false,

      orderRemarkParam:{
        orderId:null,
      }

    };
  },
  computed: {
    ...mapGetters(["permissions"]),
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId ? tenantId : '1'
      };
    },
    api() {
      return api
    },
  },
  created() {
    console.log("这里拿到的流程ID为" + this.processId)

    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
    if (this.processId && !isNaN(this.processId)) this.wfData.wfEntityId = this.processId;
    console.log("这里赋值的流程信息为:-------"+this.wfData.wfEntityId)


    this.exchangeBillSubmit = this.permissions["exchangeBillSubmit"]
    this.exchangeBillUpdate = this.permissions["exchangeBillUpdate"]
    this.exchangeBillCancel = this.permissions["exchangeBillCancel"]
    this.updateManualConfirmedAmount = this.permissions["updateManualConfirmedAmount"]
    this.updateFinalConfirmWay = this.permissions["updateFinalConfirmWay"]
    this.sfSettleExchangeOrderInfoExport = this.permissions["sfSettleExchangeOrderInfoExport"]
    this.updateFinalManualConfirmedAmount = this.permissions["updateFinalManualConfirmedAmount"]


    const userInfo = store.getters.userInfo;
    console.log("网点信息:-------",store.getters.userInfo)
    if (userInfo.snUserId) {
      this.isSite = true;
    }
    console.log("是否为服务商" + this.isSite)

    // console.log(this.tenant,"tenant的值");
  },
  mounted() {
    // this.initTableList();
    this.getData();
    this.getProcessDefinitions()
    console.log(this.tenant, "tenant的值");
    console.log(this._dataId, "_dataId的值");
  },
  methods: {
    handleFinalConfirmWayChange(row) {
      // 确保两个值都存在且有效
      if (row.finalConfirmWay !== null && row.finalConfirmWay !== undefined &&
        row.manualConfirmedAmount !== null && row.manualConfirmedAmount !== undefined) {

        // 转换为数字进行计算
        const finalConfirmWay = parseFloat(row.finalConfirmWay);
        const manualConfirmedAmount = parseFloat(row.manualConfirmedAmount);

        // 验证数值有效性
        if (!isNaN(finalConfirmWay) && !isNaN(manualConfirmedAmount)) {
          // 计算并赋值给finalManualConfirmedAmount
          row.finalManualConfirmedAmount = finalConfirmWay * manualConfirmedAmount;
        }
      }
    },
    handleFinalManualConfirmedAmountChange() {
      if (!this.formData.wkExchangeOrderDTOS || !Array.isArray(this.formData.wkExchangeOrderDTOS)) {
        return 0;
      }

      this.formData.amount = this.formData.wkExchangeOrderDTOS.reduce((total, item) => {
        try {
          // 尝试转换为数字
          const amount = Number(item.finalManualConfirmedAmount);
          // 检查转换结果是否为有效数字
          return total + (isNaN(amount) ? 0 : amount);
        } catch (error) {
          // 如果转换过程中出现异常，视为0
          return total + 0;
        }
      }, 0);
    },
    //导出
    doExcle(){
      // const  result =
      this.$mask.open()
      doCheckExcle(fileNames.site).then(response => {
        if (response.data.msg=="success"){
          doDownLoadExcle(api.sfExchangeOrder.doExcelUrl, {id: this.dataId}).then(res => {
            this.$mask.close()
            this.$message({
              type: res.data.type,
              message: res.data.content
            })
          }).catch(() => {
            this.$mask.close()
          })
        }else{
          this.$mask.close()
          this.$message({
            type: "error",
            message: response.data.msg
          });
        }
      }).catch(() => {
        this.$mask.close()
      })
    },
    doReplaceBarcodeCheck(type){
      this.showZKDialog = false
    },
    handleRowAction(row){
      this.orderRemarkParam.orderId = row.id
      this.showZKDialog = true
    },
    reloadData(){
      this.getData()
    },
    showImportManualConfirmedAmount() {
      this.$refs.ManualConfirmedAmountExcel.show()
    },
    showImportFinalConfirmWay() {
      this.$refs.FinalConfirmWayExcel.show()
    },
    reloadWf() {
      console.log('保存前的刷新');
      // this.$emit('editViewDataUpdate')
      this.reload()
    },
    openVideo(value) {
      this.imgVisbleURL = value
      this.showPreview = true
    },
    closeD33() {
      this.showPreview = false
    },
    // 下载图片
    downDocument(name,url){
      console.log(name,url, "打开");
      const x = new XMLHttpRequest()
      x.open('GET', url, true)
      x.responseType = 'blob'
      x.onload = function () {
        const url = window.URL.createObjectURL(x.response)
        const a = document.createElement('a')
        a.href = url
        a.download = name
        a.click()
      }
      x.send()

    },
    handleClick(tab, event) {
      console.log(tab, event);
      console.log(tab.name, "name得值");
      if (tab.index == 0) {
        this.card = true
      } else {
        this.card = false
      }
    },

    selectChangeEvent(data) {
      console.log('选中数据', data)
      this.selectedData = data.records
    },



    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http({
          url: api.sfExchangeOrder.getDataUrl,
          method: 'post',
          data: {
            id: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          let data = response.data.data
          if (!data.wkExchangeOrderDTOS) {
            data.wkExchangeOrderDTOS = []
          }
          this.formData = data
          this.fixData = {...{}, ...data}

        })
      } else {
        this.enabled = true;
      }
    },

    //     // 文件下载
    handleDownload(Vname,Vurl) {
      console.log(Vname,Vurl, "文件下载");
      // let url=file.type
      let url = Vurl
      let name = Vname

      const x = new XMLHttpRequest()
      x.open('GET', url, true)
      x.responseType = 'blob'
      x.onload = function () {
        const url = window.URL.createObjectURL(x.response)
        const a = document.createElement('a')
        a.href = url
        a.download = name
        a.click()
      }
      x.send()


      // window.open(url,'_blank');
    },


    viewApplicationDetails(row) {
      this.currentRowId = row
      console.log(row, "command,b的值");
      this.viewDetailsDialog = true
    },

    // 卡片事件
    //点击查看图片
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
      // console.log(fileList, "已上传文件")
    },
    // 上传发生变化钩子
    // 注意 :on-remove="handleimageChange"与:on-change="handleimageChange" 都绑定这个方法，这样无论是上传图片还是移除图片，都会更新图片数据列表
    handleimageChange(file, fileList) {
      this.upload_img = fileList;
      // this.upload_img.imageName=fileList.name;
      console.log(fileList, "文件状态改变时")
      console.log(file, "文件状态改变时file")
    },

    //导出明细
    doExcleDetail() {
      doCheckExcle(fileNames.settleDetail).then(response => {
        if (response.data.msg=="success"){
          doDownLoadExcle(api.sfBatchSettle.doExcelUrl, this.formData).then(res => {
            this.$mask.close()
            this.$message({
              type: res.data.type,
              message: res.data.content
            })
          }).catch(() => {
            this.$mask.close()
          })
        }else{
          this.$mask.close()
          this.$message({
            type: "error",
            message: response.data.msg
          });
        }
      }).catch(() => {
        this.$mask.close()
      })
    },

    getProcessDefinitions() {
      request({
        url: api.act.getProcessDefinitionsUrl,
        method: 'post',
        // data:this.formData,
        data: {tableKey: "SfSettleExchangeOrderBatch",},
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        this.processDefinitions = response.data.data
      })
    },
    update(){
      if (!this.formData.applyContent || this.formData.applyContent=='') {
        this.$message.error('请先填写申请内容');
        return;
      }
      this.$baseConfirm('您确定要保存数据吗？').then(() => {
        this.$mask.open()
        this.$http({
          url: api.sfExchangeOrder.updateDataUrl,
          method: 'post',
          data: this.formData,
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          if (response.data.type == "success") {
            this.$message({message: response.data.content, type: 'success'});
            this.reload();
          } else {
            this.$message({message: response.data.content, type: 'warning'});
          }
          this.$mask.close()
        }).catch(error => {
          console.error(error)
          this.$mask.close()
        })
      })
    },
    cancel(){
      this.$baseConfirm('您确定要取消结算吗？').then(() => {
        this.$mask.open()
        this.$http({
          url: api.sfExchangeOrder.cancelDataUrl,
          method: 'post',
          data: {
            id: this.formData.id
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          if (response.data.type == "success") {
            this.$message({message: response.data.content, type: 'success'});
            this.reload();
          } else {
            this.$message({message: response.data.content, type: 'warning'});
          }
          this.$mask.close()
        }).catch(error => {
          console.error(error)
          this.$mask.close()
        })
      })
    },
    startFlow() {
      if (!this.processDefinitions || this.processDefinitions.length < 1) {
        this.$message.error('未获取到退换货结算单流程');
        return;
      }
      if (!this.formData.applyContent || this.formData.applyContent=='') {
        this.$message.error('启动流程前请先填写申请内容并保存');
        return;
      }
      let processDefinitionId = null
      console.log("processDefinitionId")
      this.processDefinitions.forEach(element => {
        if (element.wfName == ("退换货结算单")) {
          processDefinitionId = element.id
        }
      });
      console.log("processDefinitionId", processDefinitionId)
      if (!processDefinitionId) {
        this.$message.error('未找到对应流程');
        return;
      }
      this.$baseConfirm('您确定要启动流程吗？').then(() => {
        this.$mask.open()
        this.$http({
          url: api.act.startWfUrl,
          method: 'post',
          data: {
            id: this.formData.id,
            tableKey: "SfSettleExchangeOrderBatch",
            orgId: this.formData.orgId,
            orderNo: this.formData.batchNo,
            processDefinitionId: processDefinitionId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          if (response.data.type == "success") {
            this.$message({message: response.data.content, type: 'success'});
            this.$http({
              url: api.sfExchangeOrder.startBatchUrl,
              method: 'post',
              data: this.formData,
              isLoading: true,
              modalStrictly: true,
            }).then(response => {
              if (response.data.type == "success") {
                this.$message({message: response.data.content, type: 'success'});
                this.getData()
                this.$mask.close()
              } else {
                this.$message({message: response.data.content, type: 'warning'});
                this.$mask.close()
              }
            })
            this.$mask.close()
            this.reload();
          } else {
            this.$message({message: response.data.content, type: 'warning'});
          }
        })
      })
    },
  },
};
</script>
<style lang="scss" scoped>
#containt .detail-wrap .d-header {
  margin: -6px 0px 0 -12px !important;
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
}

.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.header_dialog {
  border-radius: 8px !important;
  height: 800px !important;
}

el-dialog {
  border-radius: 8px !important;
  box-shadow: 0 0 24px rgb(0 0 0 / 22%) !important;
}

v::deep .el-upload .el-upload--picture-card {
  position: relative;
  left: -200px;
}

// 单选框
.radio_item {
  width: 24%;
  margin-top: 10px;
  margin-bottom: 10px !important;

  >span {
    display: inline-block;
    width: 120px;
    margin-right: 13px;
    text-align: right;
    font-weight: 400;
    color: rgba(86, 86, 86, 0.96);
    font-size: 12px;
  }
}

.firm {
  .el-input {
    width: 150px;
  }
}

.type_title {
  font-weight: 400;
  text-align: right;
  width: 112px;
  position: relative;
  padding: 0 10px 0 4px;
  color: rgba(86, 86, 86, 0.96);
  font-size: 12px;
}

.type_select {
  width: 120px;
  text-align: center;
}

.type_brand {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;

  >div {
    margin: 16px 0;
    width: 25%;
  }
}

// 备注的样式
.annotate {
  padding: 0px !important;
  height: 28px !important;
  min-height: 28px !important;
}

.el-textarea__inner {
  padding: 0px !important;
  height: 28px !important;
  min-height: 28px !important;
}



::v-deep.el-upload-list__item.is-success .el-upload-list__item-status-label {
  display: none !important;
}

// 输入框的宽度
// #containt .table-detail tbody tr td .el-input {
//   width: 100% !important;
//   width: 0 !important;
// }

// Switch 开关  标题的宽度
.el-switch__label * {
  line-height: 1;
  width: 160px !important;
  display: inline-block;
  font-weight: 400;
  color: rgba(86, 86, 86, 0.96);
  font-size: 12px;
}

// 清楚表格 默认padding
.el-table--medium .el-table__cell {
  padding: 0px 0 !important;
}

.table_item {
  .el-table__row:hover>td {
    background-color: #D4E7FF !important;
  }
}

.pic_item {

  .el-upload--picture-card {
    margin-top: 1px;
    width: 36px !important;
    height: 36px !important;
    line-height: 46px !important;
  }
}

// 卡片样式
.card_item {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;


  .el-card__header {
    padding: 10px 20px 5px;
    border-bottom: 1px dashed #7a7e7c;
    font-weight: 600;
    font-size: 13px;
  }

  .el-card__body,
  .el-main {
    padding: 10px 20px;
  }

  .text {
    font-size: 12px;
  }

  .item {
    margin-bottom: 12px;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 30%;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 1px solid #ccc !important;
  }
}

.papers {
  margin-left: 30px;
  position: absolute;

  ::v-deep.el-upload-list .el-upload-list__item {
    display: inline-block;
    width: 147px !important;
    margin-right: 14px;
    border-radius: 2px;
    border-color: #e8e8e8;
    margin-top: 7px;
    margin-left: 15px;
    padding: 0px !important;
    background-color: #e1e1e1;
    height: 20px;
  }

}

.btn_zdy {
  margin: 10px 0;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

.btn_zdy2 {
  // 选取文件合同按钮
  // margin: 10px 60px;
  margin-top: 6px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy2:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

::v-deep .el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0 0 0 0px !important;
}

// 步骤条
::v-deep .el-card__body,
.el-main {
  padding: 0px !important;
  font-size: 12px;
}

.task {
  color: #62f382;
}

.card {
  padding: 0px 1px;
  background-color: #efefef;
}

.el-timeline {
  margin-top: 40px;
  margin: 0;
  list-style: none;
  margin-left: 6px;
  border: 1px solid #fbfbfb;
  padding-top: 12px;
  height: 380px;
  overflow-y: scroll;
  background-color: #f2f2f2;
  padding-left: 10px !important;
}

.title_icon1 {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #409EFF;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

.title_icon {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #00c4b3;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

::v-deep .el-timeline-item__node {
  background-color: #ffffff !important;
  border: 1px solid #0550ef;
}

.bread {
  span {
    color: rgba(86, 86, 86, 0.96) !important;
  }

  ::v-deep .el-collapse-item__content {
    padding-bottom: 0px;
    background-color: #efefef;

  }
}

.card_bread {
  position: relative !important;
}

::v-deep .el-tabs__content {
  overflow: visible !important;

}

#containt .detail-wrap .d-cont {
  overflow: unset !important;
}

// .el-timeline-item {
//   position: relative;
//   padding-bottom: 0px !important;
//   margin-left: 47px;
// }
.el-timeline-item[data-v-2cf56cc1] {
  position: relative;
  margin-left: 5px;
  padding-bottom: 0px !important;
}

// 滚动条样式

/* 滚动条 */
::-webkit-scrollbar {
  width: 5px;
  height: 12px;
}

/* 滚动槽 */
::-webkit-scrollbar-track {
  border-radius: 0px;
  // background: rgba(224, 7, 7, 0.05);
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 00px;
  background: #cfcece;
}

// 步骤条 圆的位置
::v-deep .el-timeline-item__node--normal {
  left: 0px !important;
  width: 12px;
  height: 12px;
}

.el-timeline[data-v-2cf56cc1] {
  position: relative !important;
}

#containt .detail-wrap .d-cont .d-item {
  border: solid 1px #e9e9e9;
  padding: 0 12px 6px;
  position: relative !important;
}

::v-deep .el-collapse-item__arrow {
  position: absolute !important;
  top: 12px !important;
  right: 0 !important;
  font-size: 18px;
  color: #00c4b3 !important;
}

.btn_zdy {
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

::v-deep .el-collapse-item__content {
  padding-bottom: 0px !important;
}


// 本单费用位置
.expense {
  position: absolute;
  right: 20%;
  margin-top: 5px;
  color: #00c4b3;
  font-size: 13px;
}

::v-deep .el-image__preview {
  width: 60px !important;
  height: 60px !important;
}

.pic_main {
  display: flex;
  margin-left: 75px;
  margin-top: 10px;

  .pic_item {
    display: flex;
    margin-right: 40px;

    span {
      line-height: 60px;
      font-size: 12px;
      color: rgba(86, 86, 86, 0.96);
      font-weight: 400;

    }
  }
}

// 步骤条
.el-steps--simple {
  margin: 20px 0 6px;
}

.el-step.is-simple {
  width: 225px;
}

.audit {
  span {
    font-size: 12px;
    color: rgba(86, 86, 86, 0.96);
    font-weight: 400;
  }
}

// 卡片样式
.card_item {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;


  .el-card__header {
    padding: 10px 20px 5px;
    border-bottom: 1px dashed #7a7e7c;
    font-weight: 600;
    font-size: 13px;
  }

  .el-card__body,
  .el-main {
    padding: 10px 20px;
  }

  .text {
    font-size: 12px;
  }

  .item {
    margin-bottom: 12px;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 30%;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 1px solid #ccc !important;
  }
}

// 折叠样式对其
// .table-detail {
//   tr{
//     display:block;
//   }
// }
#containt .table-detail tbody tr th {
  display: table-cell;
  vertical-align: middle;
}

#containt .table-detail tbody tr td {

  display: table-cell;
  vertical-align: middle;
}

.title_time {
  margin-top: -13px;
  font-size: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .span1 {
    color: #00c4b3 !important;
    width: 35%;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .span2 {
    margin-right: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

}


// 字段之间的距离
#containt .table-detail tbody tr td {
  padding: 5px 12px;
  width: 172.2px;
  height: 27.2px !important;
  word-break: break-word;
}

.information {
  padding: 4px 10px;
  background-color: #E1F2FF;
  color: #268AEA;
  border-radius: 3px;
  margin: 0 5px;
}

#containt .table-detail tbody tr th {
  width: 6vw !important;
}

#containt .table-detail tbody tr td {
  width: 10vw !important;
  ;
}

::v-deep .el-step__title {
  font-size: 11px;
  line-height: 25px;
}
.FileName{
  display: inline-block;
    width: 140px;
    height: 40px;
margin-right: 10px;
    border-radius: 2px;
    color: #606266;
    border-color: rgb(232, 232, 232);
    margin-top: 0px;

    background-color: rgb(233, 233, 233);
    padding: 0px !important;
}
</style>
